import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Icon } from '@iconify/react'
import { useMemo } from 'react'

import { Modal, useGlobalState, Spin } from '@pepper/ui'

import {
  CMP_SALES_CONTACT_URL,
  BOOK_A_DEMO_URL,
} from 'utils/constants/website_urls'

import { useSubscriptionPlans } from './plans'
import { COPY, PREMIUM_FEATURES } from './constants'
import s from './BuyCMP.module.css'

type Props = {
  id?:
    | 'aiContentCreation'
    | 'keywords'
    | 'topics'
    | 'seoPositionTracking'
    | 'seoContentResearch'
    | 'seoContentRefresh'
    | 'teamManagement'
}

export const BuyCMP = NiceModal.create(({ id }: Props) => {
  const { visible, remove } = useModal('buy-cmp')
  const { subscription, trialExhaust } = useGlobalState()
  const { data: plans } = useSubscriptionPlans()
  const premiumPlan = plans?.find(plan => plan.name === 'Premium')
  const hasLimitExhausted = id && trialExhaust?.[id]

  const status = useMemo(() => {
    if (hasLimitExhausted) {
      return 'limit_exhausted'
    } else if (subscription?.trialStatus === 'expired') {
      return 'trial_expired'
    } else {
      return 'trial_not_started'
    }
  }, [])

  return (
    <Modal
      className={s.modal}
      title={null}
      footer={null}
      visible={visible}
      closable={true}
      onCancel={remove}
    >
      {premiumPlan ? (
        <div className={s.content}>
          <p className={s.topText}>{COPY[status].topText}</p>
          <h2 className={s.title}>{COPY[status].title}</h2>
          <p className={s.description}>{COPY[status].description}</p>
          <div className={s.card}>
            <h3 className={s.cardTitle}>
              Premium Plan <small>✨</small>
            </h3>
            <p className={s.carSubTitle}>
              Everything you need to succeed in SEO & Content Marketing in one
              platform!
            </p>
            <b>Features include</b>
            <ul className={s.list}>
              {PREMIUM_FEATURES.map((feature: string) => (
                <li key={feature}>
                  <Icon className={s.icon} icon="charm:tick" />
                  {feature}
                </li>
              ))}
            </ul>

            {status === 'trial_not_started' ? (
              <a
                className={s.button}
                href={BOOK_A_DEMO_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Book a Demo
              </a>
            ) : (
              <a
                className={s.button}
                href={CMP_SALES_CONTACT_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Sales
              </a>
            )}
          </div>
        </div>
      ) : (
        <div className={s.loader}>
          <Spin />
        </div>
      )}
    </Modal>
  )
})
